/* eslint max-classes-per-file: 0 */

import {
  LkPublication as Data,
  LkPublicationCollection as Collection,
} from '@/typings/api/Publication'
import { TransformerDAll } from '@/store/createCrudModule/TransformerData'
import { LkPublicationsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, TransformerData, Adapter } = Fabric<Data, Collection>()

export class LkPublicationsTransformerParams extends TransformerParams {
  protected defaultParams = ['slug', 'topic_slug'];

  protected per_page = 'pageSize';
}

export class LkPublicationsTransformerData extends TransformerData {
  protected readonly transformerAll: TransformerDAll = (response) => ({
    ...response,
    // @ts-ignore TODO:
    data: response.publications,
  });
}

export class LkPublicationsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new LkPublicationsTransformerParams();

  public readonly transformerData = new LkPublicationsTransformerData();
}
